import { jsx, jsxs } from 'react/jsx-runtime';
import { Icon } from '../icon.js';

function Chevron(props) {
  return /* @__PURE__ */ jsx(Icon, { ...props, children: /* @__PURE__ */ jsxs(
    "svg",
    {
      "aria-labelledby": "chevron-icon",
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      role: "img",
      children: [
        /* @__PURE__ */ jsx("title", { id: "chevron-icon", children: "A chevron icon" }),
        /* @__PURE__ */ jsx("path", { d: "M12.0001 15.0815C11.8508 15.0815 11.7079 15.0557 11.5713 15.004C11.4347 14.9524 11.3104 14.8706 11.1985 14.7586L6.60445 10.1646C6.39321 9.95339 6.2876 9.68817 6.2876 9.36897C6.2876 9.04977 6.39321 8.78455 6.60445 8.57332C6.81568 8.36209 7.0809 8.25647 7.4001 8.25647C7.7193 8.25647 7.98451 8.36209 8.19575 8.57332L12.0001 12.3777L15.8044 8.57332C16.0157 8.36209 16.2809 8.25647 16.6001 8.25647C16.9193 8.25647 17.1845 8.36209 17.3957 8.57332C17.607 8.78455 17.7126 9.04977 17.7126 9.36897C17.7126 9.68817 17.607 9.95339 17.3957 10.1646L12.8017 14.7586C12.6898 14.8706 12.5655 14.9524 12.4289 15.004C12.2923 15.0557 12.1494 15.0815 12.0001 15.0815Z" })
      ]
    }
  ) });
}

export { Chevron as default };
